import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { DropdownObjectType } from '../../shared/types';

@Component({
  selector: 'taxonomy-version-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './taxonomy-version-dropdown.component.html',
  styleUrls: ['./taxonomy-version-dropdown.component.scss'],
  animations: [
    trigger('dropdownAnimation', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateY(-10px)',
          maxHeight: '0',
        })
      ),
      state(
        '*',
        style({
          opacity: 1,
          transform: 'translateY(0)',
          maxHeight: '200px',
        })
      ),
      transition('void <=> *', animate('200ms ease-in-out')),
    ]),
  ],
})
export class TaxonomyVersionDropdownComponent {
  @Input() contentList: DropdownObjectType[] = [];
  @Input() selectedValue: DropdownObjectType | null = null;
  @Input() listHeader: string = 'Select Version';
  @Input() dropDownWidth: string = '100%';
  @Input() isLoading: boolean = false;

  @Output() onItemSelect = new EventEmitter<DropdownObjectType>();

  isDropdownOpen = signal<boolean>(false);

  toggleDropdown() {
    if (!this.isLoading) {
      this.isDropdownOpen.set(!this.isDropdownOpen());
    }
  }

  selectItem(item: DropdownObjectType) {
    this.onItemSelect.emit(item);
    this.isDropdownOpen.set(false);
  }

  closeDropdown() {
    this.isDropdownOpen.set(false);
  }

  getDisplayText(): string {
    if (this.selectedValue) {
      return this.selectedValue.label;
    }
    return this.listHeader;
  }
}
